import {
  Select,
  MenuItem,
  TextField,
  ListSubheader,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useRef, useEffect } from "react";
import { restoreScrollX, saveScrollX } from "../utilities/scrollManager";

const UncontrolledSearchSelect = ({
  data,
  value,
  onChange,
  noDefault = false,
  optionKey = "key", // default property name for option value
  optionLabel = "value", // default property name for option label
  isReadOnly = false,
  placeholder = "Search...",
  scrollContainerRef,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const searchRef = useRef(null);

  const filteredData = data?.filter((item) =>
    item?.[optionLabel]?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      searchRef.current?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSelectChange = (val) => {
    onChange(val); // pass to parent
    // Delay restore so it happens after re-render
    setTimeout(() => {
      restoreScrollX(scrollContainerRef);
    }, 50);
  };

  return (
    <Select
      fullWidth
      size="small"
      displayEmpty
      disabled={isReadOnly}
      value={value || ""}
      onChange={(e) => {
        saveScrollX(scrollContainerRef); // before value change
        handleSelectChange(e.target.value);
      }}
      // onClick={handleInteraction}
      // onFocus={handleInteraction}
      MenuProps={{
        PaperProps: {
          style: { maxHeight: 300 },
          onKeyDown: (e) => e.stopPropagation(),
        },
      }}
      inputProps={{ "aria-label": "Without label" }}
    >
      <ListSubheader>
        <TextField
          size="small"
          placeholder={placeholder}
          fullWidth
          inputRef={searchRef}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => e.stopPropagation()}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </ListSubheader>

      {!noDefault && (
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
      )}

      {filteredData?.map((item, index) => (
        <MenuItem key={index} value={item?.[optionKey]}>
          {item?.[optionLabel]}
        </MenuItem>
      ))}

      {filteredData?.length === 0 && (
        <MenuItem disabled>
          <em>No results found</em>
        </MenuItem>
      )}
    </Select>
  );
};

export default UncontrolledSearchSelect;
